(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid-enhanced"] && !Shopify.designMode) return;
  try {
    
    class VideoGridModal extends HTMLElement {
        constructor() {
            super();
            this.modalId = 'VideoModal-{{ section.id }}';

            if (!document.getElementById(this.modalId)) {
                const template = document.createElement('template');
                template.innerHTML = this.modalHTML();
                document.body.appendChild(template.content.firstElementChild);
            }

            this.modal = document.getElementById(this.modalId);
            this.videoContainer = this.modal.querySelector('.video-modal__video-container');
            this.closeButton = this.modal.querySelector('.video-modal__close');
            this.overlay = this.modal.querySelector('.video-modal__overlay');

            this.bindEvents();
        }

        bindEvents() {
            // Only bind to video triggers, not PDF triggers
            document.querySelectorAll('.video-grid-enhanced__play-trigger').forEach(
                button => {
                    button.addEventListener('click', this.openModal.bind(this));
                }
            );

            this.closeButton.addEventListener('click', this.closeModal.bind(this));
            this.overlay.addEventListener('click', this.closeModal.bind(this));
            document.addEventListener('keyup', (event) => {
                if (event.key === 'Escape') 
                    this.closeModal();
            });
        }

        openModal(event) {
            const button = event.currentTarget;
            const videoUrl = button.dataset.videoUrl;

            // Double-check: Don't open modal for PDFs
            if (videoUrl.includes('.pdf') || videoUrl.toLowerCase().includes('pdf')) {
                return; // Let the browser handle the download
            }

            // Determine video type and create appropriate element
            let videoElement;

            if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) { 
                // Convert to embed URL if needed
                const youtubeId = this.getYoutubeId(videoUrl);
                videoElement = `<iframe 
          src="https://www.youtube.com/embed/${youtubeId}?autoplay=1" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen 
          loading="lazy">
        </iframe>`;
            } else if (videoUrl.includes('vimeo.com')) { 
                // Handle Vimeo videos
                const vimeoId = this.getVimeoId(videoUrl);
                videoElement = `<iframe 
          src="https://player.vimeo.com/video/${vimeoId}?autoplay=1" 
          allow="autoplay; fullscreen; picture-in-picture" 
          allowfullscreen 
          loading="lazy">
        </iframe>`;
            } else { 
                // Default to HTML5 video for direct video URLs
                videoElement = `<video controls autoplay>
          <source src="${videoUrl}" type="video/mp4">
          Your browser does not support the video tag.
        </video>`;
            }

            this.videoContainer.innerHTML = videoElement;
            this.modal.setAttribute('open', '');
            document.body.classList.add('overflow-hidden');

            // Focus management
            this.closeButton.focus();
        }

        closeModal() {
            this.modal.removeAttribute('open');
            document.body.classList.remove('overflow-hidden');
            this.videoContainer.innerHTML = '';
        }

        getYoutubeId(url) {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);
            return(match && match[2].length === 11)
                ? match[2]
                : null;
        }

        getVimeoId(url) {
            const regExp = /^.*(vimeo.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
            const match = url.match(regExp);
            return match
                ? match[5]
                : null;
        }

        modalHTML() {
            return `
        <div id="${
                this.modalId
            }" class="video-modal" aria-modal="true" role="dialog" aria-label="Video player">
          <div class="video-modal__overlay" tabindex="-1"></div>
          <div class="video-modal__content" role="document">
            <button class="video-modal__close" aria-label="Close" type="button">
              <span class="icon icon-close">×</span>
            </button>
            <div class="video-modal__video-container"></div>
          </div>
        </div>
      `;
        }
    }

    if (!customElements.get('video-grid-modal')) {
        customElements.define('video-grid-modal', VideoGridModal);
    }

    // Initialize the modal
    new VideoGridModal();

  } catch(e) { console.error(e); }
})();
})();
